import { Button } from '@mui/material';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import {buttonStylesGreen } from '../../Components/docsAdministrative/JsObjectStyles';
import Footer from '../../Components/shared/Footer/Footer';
import NavbarHome from '../../Components/shared/Navbar/NavbarHome';
import {DrawImageHomeExpert26,PrqHthSvg1, PrqHthSvg2, PrqHthSvg3, PrqHthSvg4, PrqHthSvg5, PrqHthSvg6, PrqHthSvg7 } from '../../data/SVGs';
import usePersistedLanguage from '../../hooks/usePersistedLanguage';
import useWindowSize from '../../hooks/useWindowSize';

function PourquoiHTH() {

    const navigate=useNavigate();
    const {device}=useWindowSize();
    const { i18n } = useTranslation();
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'instant' });
    }, [navigate]); // Trigger when the pathname changes

    usePersistedLanguage();
    return (
        <>
            <div style={{display:'flex',flexDirection:'column',alignSelf:'stretch',width:'100%',background:'white',height:'fit-content'}}>
                <NavbarHome />

                <div style={{display:'flex',flexDirection:'column',gap:'65px',alignItems:'center',alignSelf:'stretch',paddingTop:'75px'}}>
                    <div
                        className='homeExpertf44'
                        style={{
                            width:'94%',
                            height:device=='desktop'?'350px':'100%',
                            borderRadius: '20px',
                            marginTop:device=='desktop'?'90px':'30px',
                            background: '#E7EAF9',
                            flexDirection:device=='desktop'?'row':'column',
                        }}
                    >
                        <div className='prqHthframe2'>
                            <h3>
                                {i18n.t('Une solution complète performante, simple et intuitive')}
                            </h3>
                            <p className='prqHthframe4'>
                                {i18n.t('High Tech Hires met à la disposition de ses utilisateurs une plateforme innovante pour leur faciliter le travail et la collaboration. Elle a été conçue pour répondre à tous les besoins de nos utilisateurs, grâce à notre profonde compréhension de leurs exigences et attentes.')}
                            </p>
                        </div>
                        <div style={{width:device=='desktop'?'50%':'80%'}}>
                            <PrqHthSvg1 height={'100%'} />
                        </div>
                    </div>

                    <div
                        style={{
                            display:'grid',
                            gridTemplateColumns:device=='desktop'?'repeat(3,1fr)':'repeat(1,1fr)',
                            gap:'24px',
                            width: '80%',
                            alignItems: 'center',
                            //isolation: 'isolate',
                            maxWidth: '1268px',
                            minWidth: device=='desktop'?'600px':'200px',
                        }}
                    >
                        <div className='homeExpertf47'>
                            <div style={{textAlign:'left',width:'170px',height:'160px'}}>
                                <PrqHthSvg2 />
                            </div>

                            <div className='homeExpertf48'>
                                <h5
                                    className='homeExpertf16'
                                    style={{margin:0}}
                                >
                                    {i18n.t('Ergonomie')}
                                </h5>
                                <p className='homeExpertf49'>
                                    {i18n.t('Nous accordons une importance primordiale à l\'expérience de nos utilisateurs. C\'est pourquoi nous avons optimisé l\'ergonomie de notre plateforme pour la rendre simple d\'accès, facile à utiliser et surtout très efficace.')}
                                </p>
                            </div>
                        </div>

                        <div className='homeExpertf47'>
                            <div style={{textAlign:'left',width:'170px',height:'160px'}}>
                                <PrqHthSvg3 />
                            </div>
                            <div className='homeExpertf48'>
                                <h5
                                    className='homeExpertf16'
                                    style={{margin:0}}
                                >
                                    {i18n.t('MRQP')}
                                </h5>
                                <p className='homeExpertf49'>
                                    {i18n.t('Nulle part ailleurs vous ne trouverez un meilleur rapport qualité-prix. Nos tarifs sont compétitifs sur le marché et nos services riment avec intégrité et efficacité. Nous garantissons un service de qualité.')}
                                </p>
                            </div>
                        </div>

                        <div className='homeExpertf47'>
                            <div style={{textAlign:'left',width:'170px',height:'160px'}}>
                                <PrqHthSvg4 />
                            </div>
                            <div className='homeExpertf48'>

                                <h5
                                    className='homeExpertf16'
                                    style={{margin:0}}
                                >
                                    {i18n.t('Matching')}
                                </h5>
                                <p className='homeExpertf49'>
                                    {i18n.t('Ne perdez plus de temps dans vos recherches de profils qualifiés. Grâce à notre outil de matching intelligent, équipé d\'algorithmes pertinents, nous comparons les données et sélectionnons les meilleurs résultats pour vous.')}
                                </p>
                            </div>
                        </div>

                        <div className='homeExpertf47'>
                            <div style={{textAlign:'left',width:'170px',height:'160px'}}>
                                <PrqHthSvg5 />
                            </div>
                            <div className='homeExpertf48'>
                                <h5
                                    className='homeExpertf16'
                                    style={{margin:0}}
                                >
                                    {i18n.t('Fonctionnalités')}
                                </h5>
                                <p className='homeExpertf49'>
                                    {i18n.t('Profitez d\'une solution complète "Source To Pay", ergonomique et intuitive, vous permettant de gérer facilement vos candidatures, missions, comptes rendus d\'activité (CRA) et factures.')}
                                </p>
                            </div>
                        </div>

                        <div className='homeExpertf47'>
                            <div style={{textAlign:'left',width:'170px',height:'160px'}}>
                                <PrqHthSvg6 />
                            </div>
                            <div className='homeExpertf48'>
                                <h5
                                    className='homeExpertf16'
                                    style={{margin:0}}
                                >
                                    {i18n.t('Support')}
                                </h5>
                                <p className='homeExpertf49'>
                                    {i18n.t('Notre équipe technique est à votre entière disposition pour vous assister et vous aider. Vous pouvez compter sur eux pour travailler avec vous et résoudre tout problème qui pourrait survenir, peu importe où vous vous trouvez.')}
                                </p>

                            </div>
                        </div>

                        <div className='homeExpertf47'>
                            <div style={{textAlign:'left',width:'170px',height:'160px'}}>
                                <PrqHthSvg7 />
                            </div>
                            <div className='homeExpertf48'>

                                <h5
                                    className='homeExpertf16'
                                    style={{margin:0}}
                                >
                                    {i18n.t('Sécurité')}
                                </h5>
                                <p className='homeExpertf49'>
                                    {i18n.t('La sécurité des données est au cœur de nos priorités. Nous nous engageons dans notre activité à ce que la collecte et le traitement des données soient conformes au RGPD. Nos serveurs sont hébergés en France pour une meilleure protection des informations.')}
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className='homeExpertf44'>
                        <div className='homeExpertf45'>
                            <h3 className='frame101HomePage'>
                                {i18n.t('Prêt à nous rejoindre et à adopter notre solution')}
                            </h3>
                            {device!='desktop' &&
                            <DrawImageHomeExpert26 />
                            }
                            <Button
                                style={{...buttonStylesGreen(false),...{width:device=='desktop'?'auto':'100%'}}}
                                onClick={()=>{
                                    navigate('/register');
                                }}
                            >
                                {i18n.t('S\'inscrire')}
                            </Button>
                        </div>
                        {device=='desktop' &&
                        <DrawImageHomeExpert26 />
                        }
                    </div>

                </div>
                <Footer />
            </div>
        </>
    );
}

export default PourquoiHTH;